import us from '../../../defines';
import modelFactory from './model-factory';
import createReportLayer from './types/report-layer';
import createAnnotationLayer from './types/annotation-layer';
import createAnalysisLayer from './types/analysis-layer';
import createTuningLayer from './types/tuning-layer';

export function createLayer (props, type) {
  let createLayer;

  const model = modelFactory(props, type);

  if (model.Type == us.anLayerTypes.report) {
    createLayer = createReportLayer;
  } else if (model.Name === us.AnnotLayerName) {
    createLayer = createAnnotationLayer;
  } else if (model.InputAnnotationId === 0) {
    createLayer = createTuningLayer;
  } else {
    createLayer = createAnalysisLayer; // Annotation Layer should be the default type, should it not?
  }

  return createLayer(props, model);
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/layer/layer-factory.js